import React from "react";
import { Scales, FirstAidKit, UsersThree } from "@phosphor-icons/react";

/**
 * Critical review block. Pass any of:
 *  - devilsAdvocate: string[]
 *  - expectedComplications: string[]
 *  - populationsWhereMightFail: string[]
 * Renders nothing if all arrays are empty.
 */
export default function DevilsAdvocateBlock({ devilsAdvocate = [], expectedComplications = [], populationsWhereMightFail = [], testid = "devils-advocate" }) {
    const any =
        (devilsAdvocate?.length || 0) +
        (expectedComplications?.length || 0) +
        (populationsWhereMightFail?.length || 0) > 0;
    if (!any) return null;

    const Item = ({ title, items, Icon, color }) => {
        if (!items?.length) return null;
        return (
            <div data-testid={`${testid}-${title.toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="flex items-center gap-2 label-eyebrow mb-2" style={{ color }}>
                    <Icon size={14} weight="duotone" />
                    <span>{title}</span>
                </div>
                <ul className="text-sm space-y-1.5 text-[var(--ink)] leading-relaxed">
                    {items.map((x, i) => <li key={i}>• {x}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <section className="border hairline bg-[var(--cream)] p-6" data-testid={testid} data-component="devils-advocate-block">
            <div className="flex items-center gap-2 mb-4">
                <span className="label-eyebrow text-[var(--terra-2)] tracking-wider">Abogado del diablo · revisión crítica</span>
            </div>
            <p className="text-xs text-[var(--ink-2)] mb-5 italic">
                Análisis sin complacencia: limitaciones reales de la evidencia, complicaciones previsibles
                y perfiles de paciente donde la propuesta puede fracasar.
            </p>
            <div className="grid md:grid-cols-3 gap-6">
                <Item title="Dificultades y limitaciones" items={devilsAdvocate} Icon={Scales} color="var(--terra-2)" />
                <Item title="Complicaciones esperables" items={expectedComplications} Icon={FirstAidKit} color="var(--amber)" />
                <Item title="Pacientes donde puede fracasar" items={populationsWhereMightFail} Icon={UsersThree} color="var(--ink-2)" />
            </div>
        </section>
    );
}
